import { useState, useEffect } from "react";

export default function usePopOutFullScreen() {
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setIsPoppedOut(urlParams.get("poppedOut") === "true");
  }, []);

  useEffect(() => {
    if (isFullScreen) {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
          setIsFullScreen(false);
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isFullScreen]);

  useEffect(() => {
    if (isPoppedOut) {
      const handleFullScreenChange = () => {
        setIsFullScreen(!!document.fullscreenElement);
      };

      document.addEventListener("fullscreenchange", handleFullScreenChange);
      return () => {
        document.removeEventListener("fullscreenchange", handleFullScreenChange);
      };
    }
  }, [isPoppedOut]);

  const handleOpenInNewWindow = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("poppedOut", "true");

    window.open(
      currentUrl.toString(),
      "newWindow",
      "toolbar=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600,location=no,noopener,noreferrer"
    );
  };

  const handleToggleFullScreen = () => {
    if (!isFullScreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      }
      if (isPoppedOut) {
        setIsFullScreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      if (isPoppedOut) {
        setIsFullScreen(false);
      }
    }
  };

  return {
    isPoppedOut,
    isFullScreen,
    handleOpenInNewWindow,
    handleToggleFullScreen,
  };
}
